import {
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  KYDAffiliate,
} from "@common/interfaces/KYDEvent";
import { useCallback } from "react";
import { useForm } from "react-hook-form";

const EditAffiliatesModal = ({
  isOpen = false,
  affiliate,
  mode,
  onClose,
  loading,
  onEditAffiliate,
}: {
  isOpen?: boolean;
  affiliate?: KYDAffiliate;
  mode: "edit" | "delete";
  onClose: () => void;
  loading: Record<string, boolean>;
  onEditAffiliate: (affiliate: KYDAffiliate, mode: string) => void;
}) => {
  const { register, handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    criteriaMode: "all",
    values: affiliate,
  });

  const onSave = useCallback((values: KYDAffiliate) => {
    return onEditAffiliate(values, mode)
  }, [onEditAffiliate, mode])
  return (
    <Modal
      size={"xl"}
      isOpen={isOpen}
      onClose={() => onClose()}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {mode === "edit" ? "Edit Affiliate" : "Delete Affiliate"}
        </ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            {mode === "edit" ? (
              <Stack spacing={0}>
                <Text fontWeight={"medium"}>Name</Text>
                <Input
                  {...register("name")}
                  isDisabled={loading["edit_affiliate"]}
                />
              </Stack>
            ) : null}
            {mode === "delete" ? (
              <HStack>
                <Text>Are you sure you want to delete this affiliate?</Text>
                <Text fontWeight={"medium"}>{affiliate?.name}</Text>
              </HStack>
            ) : null}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={loading["edit_affiliate"]}
            onClick={() => {
              onClose();
            }}
            mr="4"
          >
            Cancel
          </Button>
          {mode === "edit" ? (
            <Button
              color="white"
              bg="green.500"
              isLoading={loading["edit_affiliate"]}
              onClick={handleSubmit(onSave)}
            >
              Save
            </Button>
          ) : null}
          {mode === "delete" ? (
            <Button
              color="white"
              bg="red.500"
              isLoading={loading["edit_affiliate"]}
              onClick={handleSubmit(onSave)}
            >
              Delete
            </Button>
          ) : null}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditAffiliatesModal;
